(() => {
  'use strict';
  const clocks = new Map();
  const collect = (scope, selector) => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  function init(scope = document) {
    collect(scope, '[data-addon-clock]').forEach(clock => {
      if (clocks.has(clock)) return;
      const value = clock.dataset.end || '';
      const end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      const digits = clock.querySelector('[data-clock-digits]');
      if (!Number.isFinite(end)) {
        digits.hidden = true;
        const hint = clock.querySelector('[data-clock-hint]');
        if (hint) hint.hidden = false;
        clock.hidden = clock.dataset.editor !== 'true';
        return;
      }
      function update() {
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        digits.hidden = remaining === 0;
        clock.querySelector('[data-clock-ended]').hidden = remaining > 0;
        clock.hidden = remaining === 0 && clock.dataset.hideExpired === 'true';
        const units = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        Object.entries(units).forEach(([unit, value]) => { clock.querySelector(`[data-clock-${unit}]`).textContent = String(value).padStart(2, '0'); });
        return remaining;
      }
      if (update() > 0) {
        const interval = setInterval(() => { if (!clock.isConnected || update() === 0) { clearInterval(interval); clocks.delete(clock); } }, 1000);
        clocks.set(clock, interval);
      }
    });
    collect(scope, '[data-addon-notice]').forEach(notice => {
      if (notice.dataset.ready) return;
      notice.dataset.ready = 'true';
      if (notice.dataset.mode !== 'inventory') return;
      let variants;
      try { variants = JSON.parse(notice.querySelector('[data-addon-inventory]')?.textContent || '[]'); } catch { variants = []; }
      const update = id => {
        const variant = variants.find(item => String(item.id) === String(id));
        const quantity = Number(variant?.quantity);
        const visible = !!variant?.managed && !!variant.available && quantity > 0 && quantity <= Number(notice.dataset.threshold);
        notice.hidden = !visible;
        if (visible) notice.querySelector('[data-notice-text]').textContent = notice.dataset.message.split('[cantidad]').join(String(quantity));
        else if (notice.dataset.editor === 'true') {
          notice.hidden = false;
          notice.querySelector('[data-notice-text]').textContent = 'El aviso aparecerá cuando una variante tenga inventario controlado dentro del límite configurado.';
        }
      };
      update(notice.dataset.selected);
      notice._gtInventoryUpdate = variant => { if (variants.some(item => String(item.id) === String(variant?.id))) update(variant.id); };
    });
    collect(scope, '[data-addon-delivery]').forEach(card => {
      const start = Math.max(1, Number(card.dataset.min) || 1), finish = Math.max(start, Number(card.dataset.max) || start);
      const businessDate = days => {
        const date = new Date();let count = 0;
        while (count < days) { date.setDate(date.getDate() + 1); if (date.getDay() !== 0 && (card.dataset.saturdays === 'true' || date.getDay() !== 6)) count++; }
        return new Intl.DateTimeFormat('es-GT', { day: 'numeric', month: 'short' }).format(date);
      };
      card.querySelector('[data-delivery-start]').textContent = businessDate(start);
      card.querySelector('[data-delivery-end]').textContent = businessDate(finish);
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    collect(event.target, '[data-addon-clock]').forEach(clock => { clearInterval(clocks.get(clock)); clocks.delete(clock); });
  });
  document.addEventListener('product:variant-change', event => {
    document.querySelectorAll('[data-addon-notice]').forEach(notice => notice._gtInventoryUpdate?.(event.detail?.variant));
  });
})();
